export enum EntitySelectorEntity {
	Deal = 'deal',
	Resource = 'resource',
	Room = 'room',
	User = 'user',
	ResourceType = 'resource-type',
	Product = 'product',
}
